import React from 'react'

const CardIelts = (props) => {
  return (
    <div className='w-1/3 bg-white rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#0D2334] border-solid border-4 border-primario overflow-hidden flex flex-col justify-between transform transition-transform duration-300 hover:-translate-y-2 text-base'>
        <div className='p-10 flex flex-col gap-5'>
            <h3 className='text-2xl font-bold text-red-500 '>
                {props.titulo}
            </h3>
            <p className='text-[#161a1d] '>
                {props.texto}
            </p>
            
        </div>
        <img src={props.url} alt={props.titulo} className='w-full'/>
    </div>
  )
}

export default CardIelts